"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractModule = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AbstractModule = class AbstractModule extends vue_property_decorator_1.Vue {
    /**
     * Default module's config.
     */
    static getInitialConfig() {
        throw new Error('AbstractModuleForm.initialConfig: This field **HAS TO** be overridden by the subclass!');
    }
    /**
     * Default module's content (schema & default values).
     */
    static getInitialContent() {
        throw new Error('AbstractModuleForm.getInitialContent(): This field **HAS TO** be overridden by the subclass!');
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false }),
    __metadata("design:type", Object)
], AbstractModule.prototype, "relatedService", void 0);
AbstractModule = __decorate([
    vue_property_decorator_1.Component({ name: 'AbstractModule' })
], AbstractModule);
exports.AbstractModule = AbstractModule;
//# sourceMappingURL=abstract-module.js.map